import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    PURCHASE_DEMAND = new Meta(1, "意向");
    PRODUCT = new Meta(2, "商品");
}
export const TYPE = new Type();
